import gql from "graphql-tag";
export default gql`
  mutation createServiceTypeV2(
    $siteId: String!
    $slugName: String!
    $typeName: String!
    $domain: String
    $typeDes: String
    $masterServiceType: String
    $image: S3ObjectInput
    $typeStatus: Boolean
    $displayOrder: Int
    $aggregatorMerchantId: String
    $isAggregatorEnabled: Boolean
    $aggregatorSystem: String
    $reservationType: String
    $weraManagedByRecaho: Boolean
    $gstEnabled: Boolean
  ) {
    createServiceTypeV2(
      input: {
        siteId: $siteId
        slugName: $slugName
        typeName: $typeName
        domain: $domain
        typeDes: $typeDes
        masterServiceType: $masterServiceType
        image: $image
        typeStatus: $typeStatus
        displayOrder: $displayOrder
        aggregatorMerchantId: $aggregatorMerchantId
        isAggregatorEnabled: $isAggregatorEnabled
        aggregatorSystem: $aggregatorSystem
        reservationType: $reservationType
        weraManagedByRecaho: $weraManagedByRecaho
        gstEnabled: $gstEnabled
      }
    ) {
      slugName
    }
  }
`;
